var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickupAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8262 13.7169C8.4313 13.726 8.97821 13.3976 9.25748 12.8611L14.6412 2.47085C14.9632 1.84772 14.8533 1.12376 14.3594 0.624734C13.8655 0.125713 13.1427 0.00935959 12.517 0.324803L8.23348 2.49154C8.07833 2.56911 7.89473 2.56781 7.74346 2.48508L3.52334 0.196817C2.90661 -0.136726 2.17998 -0.0410599 1.67186 0.443741L1.66023 0.455377C1.16245 0.938885 1.03445 1.6538 1.33699 2.28081L6.4195 12.821C6.68196 13.3653 7.22111 13.7092 7.8262 13.7182V13.7169Z",
    fill: "#21438E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4136 14.6797H1.58642C0.710267 14.6797 0 15.3896 0 16.2653C0 17.141 0.710267 17.8509 1.58642 17.8509H14.4136C15.2897 17.8509 16 17.141 16 16.2653C16 15.3896 15.2897 14.6797 14.4136 14.6797Z",
    fill: "#FEBC11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5508 18.5625H1.44825C1.29615 18.5625 1.17285 18.6858 1.17285 18.8379V18.9284C1.17285 19.0804 1.29615 19.2037 1.44825 19.2037H14.5508C14.7029 19.2037 14.8262 19.0804 14.8262 18.9284V18.8379C14.8262 18.6858 14.7029 18.5625 14.5508 18.5625Z",
    fill: "#21438E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupAddress);
export default __webpack_public_path__ + "static/media/pickup-address.c5ae1a214885f4c86dc10bc11eba8b74.svg";
export { ForwardRef as ReactComponent };